"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Paths = __importStar(require("../../../js/constants/Paths"));
const path_1 = require("../../../js/helper/path");
const component_1 = require("../helper/component");
const AuthorizationStore_1 = __importDefault(require("../stores/AuthorizationStore"));
const withAuthorization = (options) => (WrappedComponent) => {
    class WithAuthorization extends react_1.default.Component {
        static displayName;
        render() {
            const { isAuthenticated } = this.props.auth0;
            const scopes = [options?.scope, ...(options?.scopes ?? [])].filter((item) => !!item);
            if (options.allowAnonymous || AuthorizationStore_1.default.hasScopes(scopes)) {
                return react_1.default.createElement(WrappedComponent, { ...this.props });
            }
            if (!isAuthenticated) {
                this.props.auth0.loginWithRedirect({
                    redirectUri: options.redirectUri ?? window.location.origin,
                    appState: {
                        returnTo: location.pathname,
                    },
                });
                return null;
            }
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: options.redirectUri ?? (0, path_1.localePath)(Paths.PATH_HOME) });
        }
    }
    WithAuthorization.displayName = `withAuthorization(${(0, component_1.getDisplayName)(WrappedComponent)})`;
    return WithAuthorization;
};
exports.default = withAuthorization;
